// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M12,2C9.3,2,6.8,3,4.9,4.9C4.6,5.3,4.3,5.6,4,6V2.5H3V8h5.5V7h-4c0.3-0.5,0.7-0.9,1.1-1.4C9.1,2.1,14.8,2,18.3,5.5
		s3.6,9.2,0.1,12.7s-9.2,3.6-12.7,0.1C4,16.7,3,14.4,3,12H2c0,5.5,4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-restore-DkeYhSeS.js.map
